import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';
import { IRootState, IFilterState } from './contract';

const exportState: IFilterState = {
    filterModalActive: false,
    filtersAreApplied: false,
    filterModel: null
};

const mutations: MutationTree<IFilterState> = {
    toggleModal(state) {
        state.filterModalActive = !state.filterModalActive;
    }
};

const actions: ActionTree<IFilterState, IRootState> = {};

const getters: GetterTree<IFilterState, IRootState> = {};

const namespaced: boolean = true;

export const filter: Module<IFilterState, IRootState> = {
    namespaced,
    state: exportState,
    getters,
    actions,
    mutations
};
